export function Footer() {
  return (
    <footer className="footer">
      <span>© 2026 </span>
      <a href="https://byross.mo" target="_blank" rel="noreferrer noopener">
        byRoss
      </a>
      <span> - Sponsored by </span>
      <a href="https://digi.mo" target="_blank" rel="noreferrer noopener">
        digi.mo
      </a>
    </footer>
  )
}

